import type { Virtualizer } from '@tanstack/react-virtual';

import { SwimlaneGridCell } from './SwimlaneGridCell';

interface ISwimlaneGrid {
  rowVirtualizer: Virtualizer<HTMLDivElement, Element>;
  columnVirtualizer: Virtualizer<HTMLDivElement, Element>;
}

export function SwimlaneGrid({ columnVirtualizer, rowVirtualizer }: ISwimlaneGrid) {
  const rowVirtualItems = rowVirtualizer.getVirtualItems();
  const columnVirtualItems = columnVirtualizer.getVirtualItems();

  return (
    <div
      style={{
        height: `${rowVirtualizer.getTotalSize()}px`,
        width: `${columnVirtualizer.getTotalSize()}px`,
        gridArea: 'grid',
        position: 'relative',
      }}
    >
      {rowVirtualItems.map((virtualRow, index) => (
        <div
          key={virtualRow.key}
          data-index={virtualRow.index}
          ref={rowVirtualizer.measureElement}
          // assign progressively lower z-index to ensure that the higher rows are rendered on top
          // this is important for visibility of InlineAdd button
          style={{ position: 'relative', zIndex: rowVirtualItems.length - index }}
        >
          {columnVirtualItems.map((virtualColumn) => (
            <SwimlaneGridCell
              key={`${virtualRow.key}-${virtualColumn.key}`}
              virtualColumn={virtualColumn}
              virtualRow={virtualRow}
            />
          ))}
        </div>
      ))}
    </div>
  );
}
